<script>
    import Card from '@smui/card';
    import DataTable, {Head, Body, Row, Cell} from '@smui/data-table';
    import BoldCell from '../common/table/BoldCell.svelte'
    import LeftTextCell from "../common/table/LeftTextCell.svelte";
    import BoldLeftTextCell from "../common/table/BoldLeftTextCell.svelte";
    import LeftBoldTextCell from "../common/table/LeftBoldTextCell.svelte";
    import LoadingScreen from '../common/loading/LoadingScreen.svelte'
    import ErrorScreen from '../common/loading/ErrorScreen.svelte'
    import {getQuote} from "./quote";
    import ContactFooter from "../common/contact/ContactFooter.svelte";

</script>
{#await getQuote()}
    <LoadingScreen>Prijsindicatie</LoadingScreen>
{:then quote}
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12">
                <Card>
                    <div class="cng-card__primary cng-card__header-with-buttons">
                        <div class="mdc-typography--headline5">Prijsindicatie (Alle bedragen zijn exclusief BTW)</div>
                    </div>
                    <div class="cng-card__divider"></div>
                    <div>
                        <DataTable table$aria-label="Prijsindicatie" style="width: 100%">
                            <Body>
                            <Row>
                                <BoldCell>Omschrijving</BoldCell>
                                <LeftBoldTextCell>Aantal</LeftBoldTextCell>
                                <LeftBoldTextCell>Prijs per eenheid</LeftBoldTextCell>
                                <LeftBoldTextCell>Prijs</LeftBoldTextCell>
                            </Row>
                            <Row>
                                <Cell>Aantal bedrijven/vestigingen</Cell>
                                <LeftTextCell>{quote.organizationPrice.quantity +1}</LeftTextCell>
                                <BoldCell/>
                                <BoldCell/>
                            </Row>
                            <Row>
                                <BoldCell>Aantal eHerkenningsmiddelen</BoldCell>
                                <BoldCell/>
                                <BoldCell/>
                                <BoldCell/>
                            </Row>
                            {#each quote.pricePerLevels as pricePerLevel}
                                <Row>
                                    <Cell>Type {pricePerLevel.ehLevel}</Cell>
                                    <LeftTextCell>{pricePerLevel.basePrice.quantity}</LeftTextCell>
                                    <LeftTextCell>€ {pricePerLevel.basePrice.basePrice}</LeftTextCell>
                                    <LeftTextCell>€ {pricePerLevel.basePrice.total}</LeftTextCell>
                                </Row>
                            {/each}
                            <Row>
                                <Cell>Totaal eHerkenningsmiddelen</Cell>
                                <Cell/>
                                <Cell/>
                                <LeftTextCell>€ {quote.totalPrice.totalBasePrice}</LeftTextCell>
                            </Row>
                            <Row>
                                <BoldCell>Aantal (extra) eHerkenningsmiddelen</BoldCell>
                                <BoldCell/>
                                <BoldCell/>
                                <BoldCell/>
                            </Row>
                            {#each quote.pricePerLevels as pricePerLevel}
                                <Row>
                                    <Cell>{pricePerLevel.ehLevel} koppelingen</Cell>
                                    <LeftTextCell>{pricePerLevel.extraPrice.quantity}</LeftTextCell>
                                    <LeftTextCell>€ {pricePerLevel.extraPrice.basePrice}</LeftTextCell>
                                    <LeftTextCell>€ {pricePerLevel.extraPrice.total}</LeftTextCell>
                                </Row>
                            {/each}
                            <Row>
                                <Cell>Aantal (extra) koppelingen</Cell>
                                <Cell/>
                                <Cell/>
                                <LeftTextCell>€ {quote.totalPrice.totalExtraPrice}</LeftTextCell>
                            </Row>
                            <Row>
                                <BoldCell>Aantal OTP Responders</BoldCell>
                                <BoldCell/>
                                <BoldCell/>
                                <BoldCell/>
                            </Row>
                            <Row>
                                <Cell>OTP Responder</Cell>
                                <LeftTextCell>{quote.devicePrice.quantity}</LeftTextCell>
                                <LeftTextCell>€ {quote.devicePrice.basePrice}</LeftTextCell>
                                <LeftTextCell>€ {quote.devicePrice.total}</LeftTextCell>
                            </Row>
                            <Row>
                                <BoldCell>Totaal</BoldCell>
                                <BoldCell/>
                                <BoldCell/>
                                <BoldLeftTextCell>€ {quote.totalPrice.totalPrice}</BoldLeftTextCell>
                            </Row>
                            </Body>
                        </DataTable>
                    </div>
                    <div class="ml-2">
                        <p class="px-3">
                            *Kortingen worden alleen gegeven op middelen (niet op eenmalige kosten, spoedprocedures etc.).
                        </p>
                    </div>
                    <ContactFooter/>
                </Card>
            </div>
        </div>
    </div>
{:catch error}
    <ErrorScreen>
        Prijsindicatie
    </ErrorScreen>
{/await}
